import Section from "./Section";
import {H3, H4} from "../Headlines";
import Paragraph from "../Paragraph";
import {UsersIcon} from "@heroicons/react/24/solid";
import {ZurLeistungsuebersicht} from "./Leistungen";
import {CheckIcon} from "@heroicons/react/16/solid";
import React from "react";

interface Props {
    activeLeistung?: string | undefined;
    inListing?: boolean;
}

export default function EnergetischeErstberatung({activeLeistung, inListing = true}: Props) {
    const name = 'energetische-erstberatung';

    return <>
        {(activeLeistung === name || inListing) &&
            <Section id={name} className={'md:!pt-16 !pt-24'}>
                <div className={'flex justify-center'}>
                    <UsersIcon className={'text-green-600 h-20'}/>
                </div>
                <H3 id={'energetische-erstberatung-headline'} className={'mt-4'}>Energetische Erstberatung vor Ort</H3>
                <H4 id={'energetische-erstberatung-subheadline'} className={'mt-4'}>Ihr erster Schritt zur
                    Energieeinsparung</H4>
                <Paragraph className={'mt-8'}>
                    Unsere <span className={'font-bold'}>Energieberatung vor Ort</span> bietet Ihnen eine
                    fundierte <span className={'font-bold'}>Orientierung für Ihre energetische Sanierung</span>.
                    In einem persönlichen Termin analysieren wir den aktuellen Zustand Ihres Gebäudes, erfassen Ihre
                    individuellen
                    Wünsche und zeigen Ihnen <span
                    className={'font-bold'}>optimale Maßnahmen zur Energieeinsparung</span> auf.
                    Dabei werden Ihre finanziellen Möglichkeiten stehts berücksichtigt.
                </Paragraph>
                <ul className={'mt-8 list-none text-lg leading-8 text-gray-600 text-left lg:ml-48'}>
                    <li className={'mt-2'}><CheckIcon className={'text-green-600 h-8 mr-2 float-left'}/>Welche <span
                        className={'font-bold'}>Sanierungsmaßnahmen</span> sind sinnvoll und wirtschaftlich?
                    </li>
                    <li className={'mt-2'}><CheckIcon className={'text-green-600 h-8 mr-2 float-left'}/>Welche <span
                        className={'font-bold'}>Fördermittel</span> von KfW, BAFA oder welche steuerlichen Anreize
                        stehen zur Verfügung?
                    </li>
                    <li className={'mt-2'}><CheckIcon className={'text-green-600 h-8 mr-2 float-left'}/>Ist es sinnvoll
                        auf den höheren energetischen Standard zu sanieren?
                    </li>
                    <li className={'mt-2'}><CheckIcon className={'text-green-600 h-8 mr-2 float-left'}/>Wie können
                        Heizkosten und CO₂-Emissionen langfristig gesenkt werden?
                    </li>
                    <li className={'mt-2'}><CheckIcon className={'text-green-600 h-8 mr-2 float-left'}/>Welche
                        energetischen Standards (z.B. <span
                            className={'font-bold'}>Effizienzhaus, Einzelmaßnahmen</span>) sind realistisch erreichbar?
                    </li>
                </ul>
                <Paragraph className={'mt-8'}>
                    Ob <span className={'font-bold'}>Heizungstausch, Dämmung, Fenstererneuerung oder <span
                    className={'text-nowrap'}>Komplettsanierung –</span></span> wir
                    begleiten Sie <span className={'font-bold'}>kompetent und unabhängig</span> auf dem Weg zur besten
                    Lösung.
                </Paragraph>
                <Paragraph className={'mt-4 font-bold'}>
                    Jetzt Termin für die Vor-Ort-Energieberatung sichern und von staatlicher Förderung profitieren!
                </Paragraph>
                {inListing && <ZurLeistungsuebersicht/>}
            </Section>
        }
    </>
}